module.exports = __webpack_public_path__ + "static/media/disney-logo@2x.0f709e4c.png";